/**
 * Camera configuration. Defines how close/far the camera can go
 * and how the viewing angle changes with zoom level.
 */
export interface CameraConfig {
  /** Closest the camera gets to the surface. */
  zoomMin: number;
  /** Farthest the camera pulls back. */
  zoomMax: number;
  /** Starting zoom level. */
  zoomDefault: number;

  /**
   * Camera pitch angle range in radians.
   * pitchAtMin: angle when fully zoomed in (low = looking across the surface)
   * pitchAtMax: angle when fully zoomed out (high = looking down)
   */
  pitchAtMinZoom: number;
  pitchAtMaxZoom: number;

  /** How far the camera can see. Affects horizon visibility. */
  farPlane: number;

  /** Field of view in radians. */
  fov: number;

  /** Pan inertia damping (0-1). Higher = slides more. */
  panDamping: number;

  /** Zoom interpolation speed (0-1). Higher = snappier. */
  zoomSmooth: number;

  /** FlightView camera settings. */
  flightView: FlightViewConfig;

  /** Zoom when focusing planet for hub (smaller = planet appears bigger). */
  hubZoom: number;
}

export interface FlightViewConfig {
  zoomMin: number;
  zoomMax: number;
  zoomDefault: number;
  pitchAtMinZoom: number;
  pitchAtMaxZoom: number;
  transitionSpeed: number;
}

export function defaultCameraConfig(): CameraConfig {
  return {
    zoomMin: 8,
    zoomMax: 35,
    zoomDefault: 35,
    pitchAtMinZoom: 0.8,
    pitchAtMaxZoom: 0.8,
    farPlane: 2000,
    fov: Math.PI / 3,
    panDamping: 0.92,
    zoomSmooth: 0.08,
    flightView: {
      zoomMin: 1.0,
      zoomMax: 4.0,
      zoomDefault: 2.0,
      pitchAtMinZoom: 0.3,
      pitchAtMaxZoom: 1.0,
      transitionSpeed: 0.4,
    },
    hubZoom: 5.5,
  };
}
